import { useAuthStore } from '@/modules/auth/stores/auth.store';
import { useAuthenticatedUserDataRefresh } from '@/modules/user/composables/useAuthenticatedUserDataRefresh';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';

/**
 * Guard de autenticación y revalidación de datos
 * Maneja rutas protegidas y rutas de visitantes
 */
export const authGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
) => {
  const auth = useAuthStore();

  // Verificar si la ruta requiere autenticación
  if (to.matched.some(record => record.meta?.requiresAuth)) {
    if (!auth.token) {
      // Redirigir al login si no hay token
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
      return;
    }

    // Si tiene token, intentar revalidar datos de usuario (TTL check)
    try {
      const { refreshIfNeeded } = useAuthenticatedUserDataRefresh();
      // No bloqueamos la navegación con await, se ejecuta en background
      refreshIfNeeded().catch(error => {
        console.error('[Router] Error al revalidar datos de usuario:', error);
      });
    } catch (error) {
      console.error('[AuthGuard] Error refreshing user data:', error);
    }

    // Continuar navegación
    next();
  }
  // Verificar si la ruta es solo para visitantes (login, registro)
  else if (to.matched.some(record => record.meta?.requiresVisitor)) {
    if (auth.token) {
      // Si ya tiene sesión, redirigir al home
      next({ path: '/' });
      return;
    }
    next();
  }
  // Rutas públicas
  else {
    next();
  }
};
